import styled from 'styled-components';
import { font, Flex, useResponsiveValue } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { COLORS } from '@lemonade-hq/tokens';

const Floater = styled(Flex)`
  position: absolute;
  text-transform: uppercase;
  z-index: 1;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  user-select: none;

  ${MEDIA_QUERIES.mobile`
        height: ${props => props.width[0]}px;
        ${font('main', { fontSize: '12px', fontWeight: 700 })}
    `}

  ${MEDIA_QUERIES.tablet`
        height: ${props => props.width[1]}px;
        ${font('main', { fontSize: '12px', fontWeight: 700 })}
    `}

    ${MEDIA_QUERIES.desktop`
        height: ${props => props.width[2]}px;
        ${font('main', { fontSize: '18px', fontWeight: 700 })}
    `};
`;

export default function Giveback2020Floater({ t, tt, gray, children, ...props }) {
  const rightTT = useResponsiveValue(tt);
  const startT = rightTT[0];

  const style = {
    backgroundColor: t < startT ? 'transparent' : COLORS.pink,
    color: gray ? COLORS.cloud : COLORS.white,
  };

  return (
    <Floater style={style} {...props}>
      {children}
    </Floater>
  );
}
